import { createContext } from 'react';
import { ICannedMessages } from './provider';

const CannedMessagesContext = createContext<ICannedMessages>({} as ICannedMessages);

export default CannedMessagesContext;
